var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgImgRivenditore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.175,
    height: 81.967,
    viewBox: "0 0 85.175 84.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10152",
    "data-name": "Tracciato 10152",
    d: "M10.325,33h54.2V74.018H3V40.325A7.325,7.325,0,0,1,10.325,33Z",
    transform: "translate(-3 10.948)",
    fill: "#e9f1f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10153",
    "data-name": "Tracciato 10153",
    d: "M64.528,59.369V74.018H3V40.325A7.325,7.325,0,0,1,10.325,33H14.72v8.79A17.579,17.579,0,0,0,32.3,59.369Z",
    transform: "translate(-3 10.948)",
    fill: "#d0d8da"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10154",
    "data-name": "Tracciato 10154",
    d: "M45,28H61.114a7.325,7.325,0,0,1,7.325,7.325V76.343H45Z",
    transform: "translate(16.528 8.624)",
    fill: "#b8bebf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10155",
    "data-name": "Tracciato 10155",
    d: "M60.808,11.79V46.948H11V3H28.579Z",
    transform: "translate(0.72 -3)",
    fill: "#e9f1f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10156",
    "data-name": "Tracciato 10156",
    d: "M60.808,32.3V46.948H11V3H28.579v7.325A21.982,21.982,0,0,0,50.554,32.3Z",
    transform: "translate(0.72 -3)",
    fill: "#d0d8da"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1083",
    "data-name": "Rettangolo 1083",
    width: 34.701,
    height: 6.309,
    transform: "translate(28.392 50.266)",
    fill: "#e4eac3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1084",
    "data-name": "Rettangolo 1084",
    width: 31.546,
    height: 6.309,
    transform: "translate(31.546 9.256)",
    fill: "#e4eac3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1085",
    "data-name": "Rettangolo 1085",
    width: 34.701,
    height: 6.309,
    transform: "translate(28.392 56.575)",
    fill: "#e4eac3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1086",
    "data-name": "Rettangolo 1086",
    width: 34.701,
    height: 3.155,
    transform: "translate(28.392 62.884)",
    fill: "#e4eac3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1093",
    "data-name": "Rettangolo 1093",
    width: 15.773,
    height: 6.309,
    transform: "translate(69.402 72.348)",
    fill: "#ade8f4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1094",
    "data-name": "Rettangolo 1094",
    width: 31.546,
    height: 3.155,
    transform: "translate(31.546 21.874)",
    fill: "#e4eac3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1095",
    "data-name": "Rettangolo 1095",
    width: 31.546,
    height: 6.309,
    transform: "translate(31.546 31.338)",
    fill: "#e4eac3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1096",
    "data-name": "Rettangolo 1096",
    width: 6.309,
    height: 18.928,
    transform: "translate(18.928 18.72)",
    fill: "#e4eac3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10159",
    "data-name": "Tracciato 10159",
    d: "M55.694,42.86H22V37h2.93Z",
    transform: "translate(5.834 12.808)",
    fill: "#899b3c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10160",
    "data-name": "Tracciato 10160",
    d: "M54.3,30.86H25V25h2.93Z",
    transform: "translate(7.229 7.229)",
    fill: "#899b3c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10161",
    "data-name": "Tracciato 10161",
    d: "M54.3,22.86H25V17h2.93Z",
    transform: "translate(7.229 3.509)",
    fill: "#899b3c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10162",
    "data-name": "Tracciato 10162",
    d: "M54.3,14.86H25V9h2.93Z",
    transform: "translate(7.229 -0.21)",
    fill: "#899b3c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10163",
    "data-name": "Tracciato 10163",
    d: "M55.694,46.86H22V41h2.93Z",
    transform: "translate(5.834 14.668)",
    fill: "#899b3c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10164",
    "data-name": "Tracciato 10164",
    d: "M55.694,50.86H22V45h2.93Z",
    transform: "translate(5.834 16.528)",
    fill: "#899b3c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10167",
    "data-name": "Tracciato 10167",
    d: "M65.649,57.86H51V52h1.465Z",
    transform: "translate(19.317 19.782)",
    fill: "#48cae4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10168",
    "data-name": "Tracciato 10168",
    d: "M23.79,32.579,15,15V35.509h8.79Z",
    transform: "translate(2.579 2.579)",
    fill: "#899b3c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10169",
    "data-name": "Tracciato 10169",
    d: "M68.439,63.159V76.343H45V28h4.395V52.9A10.255,10.255,0,0,0,59.649,63.159Z",
    transform: "translate(16.528 8.624)",
    fill: "#93999a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10170",
    "data-name": "Tracciato 10170",
    d: "M33.086,22.86H25V17h1.465a22.083,22.083,0,0,0,6.622,5.86Z",
    transform: "translate(7.229 3.509)",
    fill: "#255300"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10176",
    "data-name": "Tracciato 10176",
    d: "M58.79,31H51.465a1.465,1.465,0,0,0,0,2.93H58.79a1.465,1.465,0,0,0,0-2.93Z",
    transform: "translate(18.852 10.018)",
    fill: "#e4eac3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImgRivenditore);
export default __webpack_public_path__ + "static/media/SvgImgRivenditore.c6fe3ecdcfdd7d941a706b0d647d04b7.svg";
export { ForwardRef as ReactComponent };